var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tracked-ui",class:{
    visible: _vm.visible,
  },style:(`
    top: ${_vm.coords.y}%;
    left: ${_vm.coords.x}%;
  `)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }